// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__15egR","additionalInfo":"AgreementModal_additionalInfo__30lWF"};